/**
 * cat-nav.js — cây danh mục 3 cấp ở hero trang chủ.
 *
 * Markup đầu vào chỉ cần đúng output của wp_nav_menu( ['depth' => 3] ):
 *   [data-cat-nav] ul.menu > li.menu-item.menu-item-has-children > a + ul.sub-menu
 * Nút caret (.dropdown-toggle) do script này chèn, giống navigation.js của theme _s,
 * nên PHP không phải sinh thêm markup.
 *
 * Desktop: panel cấp 2 mở bằng CSS hover/focus-within (trễ 120ms), bấm caret để ghim.
 * Mobile:  panel chạy accordion, chỉ mở một nhóm tại một thời điểm.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var DESKTOP_QUERY = '(min-width: 1024px)';

    var root = document.querySelector('[data-cat-nav]');
    if (!root) return;

    var parents = [].slice.call(root.querySelectorAll('.menu > .menu-item.menu-item-has-children'));
    if (!parents.length) return;

    function isDesktop() {
        return window.matchMedia(DESKTOP_QUERY).matches;
    }

    function setPanel(item, open) {
        item.classList.toggle('is-open', open);
        var button = item.querySelector('.dropdown-toggle');
        if (button) {
            button.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    }

    function closeAll(except) {
        parents.forEach(function (item) {
            if (item !== except) setPanel(item, false);
        });
    }

    parents.forEach(function (item) {
        var link = item.querySelector(':scope > a');
        if (!link) return;

        var button = document.createElement('button');
        button.className = 'dropdown-toggle';
        button.type = 'button';
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', 'Open submenu of ' + link.textContent.trim());
        button.innerHTML = '<i class="ph ph-caret-right" aria-hidden="true"></i>';
        link.insertAdjacentElement('afterend', button);

        button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            var willOpen = !item.classList.contains('is-open');
            closeAll(item);
            setPanel(item, willOpen);
        });

        // Tab ra khỏi nhánh thì đóng panel lại (desktop panel phủ lên slider)
        item.addEventListener('focusout', function (event) {
            if (isDesktop() && !item.contains(event.relatedTarget)) {
                setPanel(item, false);
            }
        });
    });

    document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') closeAll();
    });

    // Đổi breakpoint: accordion và panel là hai trạng thái khác nhau, dọn cho sạch
    var resizeTimer;
    window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
            closeAll();
        }, 200);
    });
})();
